import { CardBase, CardBaseHeader } from '@facephi/ui-react';
import styled from 'styled-components';

export const NetworkCard = styled(CardBase)`
  padding: 2.4rem 3.4rem;
  width: 100%;
`;

export const CardBaseHeaderStyled = styled(CardBaseHeader)`
  padding: 0;
`;
